/* ============================================================
   InternationalPermit.net  -  Global JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE NAV ──
  const toggle = document.querySelector('.nav-toggle');
  const nav    = document.querySelector('.main-nav');
  if (toggle && nav) {
    // Insert close button
    const closeBtn = document.createElement('button');
    closeBtn.className = 'nav-close-btn';
    closeBtn.innerHTML = '✕';
    closeBtn.setAttribute('aria-label', 'Close menu');
    nav.prepend(closeBtn);

    toggle.addEventListener('click', () => {
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    closeBtn.addEventListener('click', () => {
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
    document.addEventListener('click', (e) => {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && e.target !== toggle) {
        nav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // ── FAQ ACCORDION ──
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item   = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      item.closest('.faq-list').querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── SMOOTH SCROLL ──
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 88, behavior: 'smooth' });
      }
    });
  });

  // ── ACTIVE NAV ──
  const path = window.location.pathname;
  document.querySelectorAll('.main-nav a:not(.nav-cta)').forEach(a => {
    const href = a.getAttribute('href') || '';
    if (href !== '/' && href !== '' && path.includes(href)) a.classList.add('active');
  });

  // ── SCROLL REVEAL ──
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity  = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.card, .pricing-card, .country-card, .step, .related-card, .stat').forEach(el => {
      el.style.opacity   = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      obs.observe(el);
    });
  }

  // ── AUTO TOC ──
  const tocWrap = document.querySelector('.auto-toc');
  if (tocWrap) {
    const headings = document.querySelectorAll('.article-body h2');
    if (headings.length > 2) {
      const ul = document.createElement('ul');
      ul.className = 'sidebar-links';
      headings.forEach((h, i) => {
        if (!h.id) h.id = 'section-' + i;
        const li = document.createElement('li');
        const a  = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        ul.appendChild(li);
      });
      tocWrap.appendChild(ul);
    } else {
      const box = tocWrap.closest('.sidebar-box');
      if (box) box.style.display = 'none';
    }
  }

  // ── PRICING HOVER DIM ──
  const pCards = document.querySelectorAll('.pricing-card');
  pCards.forEach(card => {
    card.addEventListener('mouseenter', () => pCards.forEach(c => { if (c !== card) c.style.opacity = '0.65'; }));
    card.addEventListener('mouseleave', () => pCards.forEach(c => c.style.opacity = '1'));
  });

});



document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('IdpApplicationForm');
  if (!form || form.dataset.applicationFullFix === 'true') return;

  const radios = Array.from(form.querySelectorAll('.plan-radio-card input[type="radio"][name="package_choice"]'));
  const planCards = Array.from(form.querySelectorAll('.plan-radio-card'));
  const variantInput = document.getElementById('SelectedVariantId');
  const packageProperty = document.getElementById('SelectedPackageProperty');
  const planText = document.getElementById('selectedPlanText');
  const priceText = document.getElementById('selectedPrice');
  const shipText = document.getElementById('shippingMessage');
  const errorBox = document.getElementById('applicationError');
  const checkoutButton = document.getElementById('CheckoutButton');
  const labels = ['Digital Only · Valid for 3 Years', 'Print + Digital · Valid for 1 Year', 'Print + Digital · Valid for 3 Years'];
  const prices = ['$39', '$79', '$89'];

  function selectPlan(index) {
    const radio = radios[index];
    if (!radio || radio.disabled) return;
    radio.checked = true;
    planCards.forEach((card, i) => card.classList.toggle('selected', i === index));
    if (variantInput) variantInput.value = radio.dataset.variantId || '';
    if (packageProperty) packageProperty.value = radio.dataset.package || labels[index];
    if (planText) planText.textContent = labels[index];
    if (priceText) priceText.textContent = prices[index];
    if (shipText) shipText.textContent = index === 0
      ? 'Digital delivery only. No shipping.'
      : 'Shipping address and available shipping rates are collected in Shopify Checkout.';
  }

  radios.forEach((radio, index) => radio.addEventListener('change', () => selectPlan(index)));
  const requestedPlan = Number(new URLSearchParams(window.location.search).get('plan'));
  selectPlan(Number.isInteger(requestedPlan) && requestedPlan >= 0 && requestedPlan <= 2 ? requestedPlan : 0);

  const canvas = document.getElementById('signatureCanvas');
  const fileInput = document.getElementById('signatureFile');
  const clearButton = document.getElementById('clearSignature');
  let signed = false;

  if (canvas && fileInput) {
    const ctx = canvas.getContext('2d');
    ctx.lineWidth = 2.4;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    let drawing = false;

    function point(e) {
      const r = canvas.getBoundingClientRect();
      const p = e.touches ? e.touches[0] : e;
      return {
        x: (p.clientX - r.left) * (canvas.width / r.width),
        y: (p.clientY - r.top) * (canvas.height / r.height)
      };
    }
    function start(e) {
      e.preventDefault();
      drawing = true;
      signed = true;
      const p = point(e);
      ctx.beginPath();
      ctx.moveTo(p.x, p.y);
    }
    function move(e) {
      if (!drawing) return;
      e.preventDefault();
      const p = point(e);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
    }
    function stop() { drawing = false; }

    canvas.addEventListener('pointerdown', start);
    canvas.addEventListener('pointermove', move);
    window.addEventListener('pointerup', stop);
    if (clearButton) clearButton.addEventListener('click', function () {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      signed = false;
      fileInput.value = '';
    });
  }

  function showError(message) {
    if (errorBox) {
      errorBox.textContent = message;
      errorBox.hidden = false;
      errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      alert(message);
    }
  }

  function signatureBlob() {
    return new Promise(resolve => {
      if (!canvas || !signed) return resolve(null);
      canvas.toBlob(resolve, 'image/png');
    });
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

    if (!form.reportValidity()) return;
    if (!signed) {
      showError('Please add your signature before continuing.');
      return;
    }
    if (!variantInput || !variantInput.value) {
      showError('Please select a package before continuing.');
      return;
    }

    const blob = await signatureBlob();
    if (!blob) {
      showError('Could not save your signature. Please clear it, sign again, and retry.');
      return;
    }

    try {
      const dt = new DataTransfer();
      dt.items.add(new File([blob], 'signature.png', { type: 'image/png' }));
      fileInput.files = dt.files;
    } catch (err) {
      showError('Your browser could not attach the signature image. Please use a current version of Chrome, Safari, Firefox, or Edge.');
      return;
    }

    if (checkoutButton) {
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Preparing Shopify Checkout…';
    }

    try {
      const formData = new FormData(form);
      // package_choice is only a UI control; the actual Shopify variant is sent in the hidden id field.
      formData.delete('package_choice');
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) {
        let message = 'Shopify could not add this application to checkout. Please try again.';
        try {
          const data = await response.json();
          if (data && (data.description || data.message)) message = data.description || data.message;
        } catch (_) {}
        throw new Error(message);
      }
      window.location.assign(window.Shopify.routes.root + 'checkout');
    } catch (err) {
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.textContent = 'Continue to Shopify Checkout';
      }
      showError(err.message || 'Shopify Checkout could not be opened. Please try again.');
    }
  });
});
